import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import CampaignService from "services/Campaign";
import { useCampaignTargetTable } from "hooks/useCampaignTargetTable";
import { CampaignTargetTableActionsButton } from "./CampaignTargetTableActionsButton";
import withRoleCheck from "components/hocs/withRoleCheck";
import { NewCampaignTargetModal as _NewCampaignTargetModal } from "routes/campaign/components/Modals";

export const CAMPAIGN_TARGET_TABLE_CONSTANTS = {
  tableName: "target_companies",
  className: "Entity",
  exportTableName: "CampaignTargetsTable",
  header: null,
  headerIcon: null,
};

const NewCampaignTargetModal = withRoleCheck(_NewCampaignTargetModal, [
  ACL_RELATIONSHIPS.campaignTarget.create,
]);

const CampaignTargetsTableV3 = ({
  campaignId = null,
  effectiveDate,
  campaign,
}) => {
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.entityTags.create,
      ACL_RELATIONSHIPS.entityTags.read,
      ACL_RELATIONSHIPS.entityTags.delete,
    ],
    { partialMatch: true }
  );
  const {
    filters,
    columns,
    customFields,
    queryKey,
    invalidateData,
    deleteManyCampaignTarget,
  } = useCampaignTargetTable({
    campaign,
    campaignId,
    tableName: CAMPAIGN_TARGET_TABLE_CONSTANTS.tableName,
  });

  const fetchCampaignTargets = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await CampaignService.getCampaignTargets(
          campaignId,
          nextQueryParams
        );

        return response;
      } catch (error) {
        console.error("Error fetching campaign targets:", error);
        throw error;
      }
    },
    [columns, campaignId]
  );

  const actionButtons = useCallback(
    ({ selectedIds, selectedData }) => (
      <CampaignTargetTableActionsButton
        selectedIds={selectedIds}
        selectedData={selectedData}
        campaignId={campaignId}
        effectiveDate={effectiveDate}
        deleteManyCampaignTarget={deleteManyCampaignTarget}
        invalidateData={invalidateData}
      />
    ),
    [campaignId, effectiveDate, deleteManyCampaignTarget, invalidateData]
  );

  return (
    <BaseTableV3
      rowIdKey="entity_id"
      columns={columns}
      filters={filters}
      queryKey={queryKey}
      className={CAMPAIGN_TARGET_TABLE_CONSTANTS.className}
      exportTableName={CAMPAIGN_TARGET_TABLE_CONSTANTS.exportTableName}
      tagsDropdownParams={{ visible: enableTags }}
      tableName={CAMPAIGN_TARGET_TABLE_CONSTANTS.tableName}
      downloadParams={{ campaign_id: campaignId }}
      enableSearch
      enableSettings
      customFields={customFields ?? []}
      createButton={
        <NewCampaignTargetModal
          fetchCampaignTargets={invalidateData}
          campaignId={parseInt(campaignId)}
          campaign={campaign}
        />
      }
      fetchData={fetchCampaignTargets}
      actionButtons={actionButtons}
      invalidateData={invalidateData}
    />
  );
};

export default CampaignTargetsTableV3;
